import { render, staticRenderFns } from "./approvalDetailsDialog.vue?vue&type=template&id=9a2fdea6&scoped=true"
import script from "./approvalDetailsDialog.vue?vue&type=script&lang=js"
export * from "./approvalDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2fdea6",
  null
  
)

export default component.exports